import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '暗网91是什么？',
    answer: '暗网91是深网中一个知名的信息资源平台，提供信息发布、资源分享和社区讨论等功能。用户可以通过Tor网络匿名访问该平台，获取各类信息资源。',
  },
  {
    question: '如何安全访问暗网91？',
    answer: '安全访问暗网91需要：1）安装并正确配置Tor浏览器；2）通过官方渠道获取最新.onion地址；3）使用PGP验证地址签名；4）配置Tor安全级别为"最安全"；5）建议使用VPN作为前置代理。',
  },
  {
    question: '访问暗网是否合法？',
    answer: '仅使用Tor浏览器访问暗网本身在大多数国家是合法的。但需要注意：在暗网中进行非法交易或活动是违法的。本站仅提供安全知识学习，请务必遵守当地法律法规。',
  },
  {
    question: '暗网91有哪些安全风险？',
    answer: '主要安全风险包括：钓鱼网站冒充官方入口、恶意软件通过下载传播、诈骗交易、个人隐私泄露等。通过遵守安全指南和保持警惕，可以有效规避这些风险。',
  },
  {
    question: 'Tor浏览器的安全级别如何设置？',
    answer: 'Tor浏览器提供标准、较安全和最安全三个级别。访问暗网时建议设置为"最安全"级别（点击地址栏旁的盾牌图标进行设置），这将禁用JavaScript和部分字体渲染，最大程度保护匿名性。',
  },
  {
    question: '暗网91的内容是否可靠？',
    answer: '暗网91平台本身不保证所有内容的可靠性。用户需要自行判断信息真伪，参考多方来源进行验证。建议优先关注信誉良好的发布者和经过社区验证的内容。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于暗网91的常见疑问解答
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-background-50 transition-colors duration-200 cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-foreground-500 transition-transform duration-200 text-lg`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}